import IBranchOpeningHour from '../../../interfaces/IBranchOpeningHour'

export namespace ShelterConstants {
  export const DEFAULT_OPENING_HOUR: IBranchOpeningHour[] = [
    {
      weekday_key: 'SUN',
      opening: '08:00:00',
      closure: '17:00:00',
      name: 'Sunday',
      closed: false
    },
    {
      weekday_key: 'MON',
      opening: '08:00:00',
      closure: '17:00:00',
      name: 'Monday',
      closed: false
    },
    {
      weekday_key: 'TUE',
      opening: '08:00:00',
      closure: '17:00:00',
      name: 'Tuesday',
      closed: false
    },
    {
      weekday_key: 'WED',
      opening: '08:00:00',
      closure: '17:00:00',
      name: 'Wednesday',
      closed: false
    },
    {
      weekday_key: 'THU',
      opening: '08:00:00',
      closure: '17:00:00',
      name: 'Thursday',
      closed: false
    },
    {
      weekday_key: 'FRI',
      opening: '08:00:00',
      closure: '17:00:00',
      name: 'Friday',
      closed: false
    },
    {
      weekday_key: 'SAT',
      opening: '08:00:00',
      closure: '17:00:00',
      name: 'Saturday',
      closed: false
    }
  ]
}
